// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea-module__label--RaWGl","textarea":"Textarea-module__textarea--15iRP","helperText":"Textarea-module__helperText--3AKL3"};